import { Flex, Text } from "@chakra-ui/react";
import { ReactElement } from "react";

import { TooltipIcon } from "./tooltip-icon";

export const TooltipText = ({
  text,
  content,
  color = "fg.muted",
  fontSize,
  fontWeight,
}: {
  text: string | ReactElement;
  content: string | undefined;
  color?: string;
  fontSize?: string;
  fontWeight?: string;
}) => (
  <Flex alignItems={"center"} cursor="default" gap={1}>
    <Text color={color} fontSize={fontSize} fontWeight={fontWeight}>
      {text}
    </Text>
    {content && <TooltipIcon content={content} color={color} />}
  </Flex>
);
